export const environment = {
  production: false,
  apiUrl: 'https://as-referral-v1-d-bfe928958ad5.herokuapp.com',
}
